import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  AddEmailAddressContent,
  AddEmailErrorMessages,
  AddEmailFormAttributes,
  AddEmailPageContent
} from '../models/add-email-address.interface';

export const errorMessagesMock: AddEmailErrorMessages = {
  emailErrorMessage: {},
  confirmEmailErrorMessage: {},
  alertWarning: ''
};

export const pageContentMock: AddEmailPageContent = {
  buttonLabel: 'Continue',
  contentBodyHeader:
    'We do not have a valid email address associated with your account. You must provide a valid email address to continue.',
  emailLabel: 'Enter Email Address',
  headerSubTitle: '*fields required',
  headerTitle: 'Add Email Address',
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_loginHelp: '',
    button_modal: 'Continue',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'loginCredentials',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: '',
    overlayMessage:
      'Your password has been reset successfully. We have sent a confirmation email to your primary email address in your Delta account.',
    refreshUrl: ''
  },
  confirmEmailLabel: 'Re-Enter Email Address',
  viewName: 'addemailaddress',
  pageHeader: {
    headerSubTitle: '*fields required',
    headerTitle: 'Add Email Address',
    altText: 'logo',
    logoUrl:
      'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png'
  },
  errors: errorMessagesMock
};

export const formAttributesMock: AddEmailFormAttributes = {
  errorCount: 0,
  errorAlertBanner: false,
  emailControlTouched: false,
  confirmEmailControlTouched: false,
  disableActionButton: false,
  submitAttempt: false
};

export const addEmailAddressContentMock: AddEmailAddressContent = {
  formGroup: new UntypedFormGroup({
    email: new UntypedFormControl(null),
    confirmEmail: new UntypedFormControl(null)
  }),
  formAttributes: formAttributesMock,
  pageContent: pageContentMock,
  isSuccess: false,
  isError: false,
  message: ''
};
